import React from "react";
import { Trans } from "react-i18next";

const AddProductToWarehouseFormStep: React.FC = () => {
    return (
        <p className="fs-7 mb-0">
            <Trans
                i18nKey="tutorial.addProductToWarehouseFormStep"
                components={{
                    strong: <strong />,
                    asterisk: (
                        <span>
                            {" "}
                            (<span className="text-danger">*</span>){" "}
                        </span>
                    ),
                }}
            />
        </p>
    );
};

export default AddProductToWarehouseFormStep;
